// src/components/product-review-details/product-review-details.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment CategorizedListingsFragment on EGDSProgressBarGroup {\n    progressBars {\n      percent\n      progressDescription\n      title\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    spotLight\n    title\n    theme\n    token\n    withBackground\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...EGDSIconFragment\n      ... on Mark {\n        url {\n          ... on HttpURI {\n            value\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSHeadingFragment on EGDSHeading {\n    accessibility\n    text\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    accessibility\n    decorative\n    size\n    text\n    theme\n    weight\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSGraphicTextFragment\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment ProductTextInfoContentFragment on ProductSupportingMessage {\n    ... on EGDSParagraph {\n      ...EGDSParagraphFragment\n    }\n    ... on EGDSPlainText {\n      ...EGDSPlainTextFragment\n    }\n    ... on EGDSInlineLink {\n      ...EGDSInlineLinkFragment\n    }\n    ... on EGDSGraphicText {\n      ...EGDSGraphicTextFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment ProductTextInfoSectionFragment on ProductTextInfoSection {\n    title {\n      text\n      weight\n      theme\n      accessibility\n    }\n    tooltipContent\n    tooltipIcon {\n      id\n      title\n      size\n      theme\n    }\n    policyA11yText\n    icon {\n      description\n      id\n      token\n      theme\n      size\n    }\n    accessibilityText\n    theme\n    message {\n      title\n      content {\n        ...ProductTextInfoContentFragment\n      }\n      openAnalytics {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment ReviewDisclaimerFragment on ProductTextInfoSection {\n    ...ProductTextInfoSectionFragment\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment ReviewSummaryFragment on ProductRatingSummary {\n    primary\n    secondary\n    accessibilityLabel\n    theme\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  query PWAReviewsOverlayProductReviewDetailsQuery($productIdentifier: ProductIdentifierInput!, $context: ContextInput!) {\n    productReviewDetails(productIdentifier: $productIdentifier, context: $context) {\n      summary {\n        ...ReviewSummaryFragment\n      }\n      disclaimer {\n        ...ReviewDisclaimerFragment\n      }\n      progressBarGroup {\n        ...CategorizedListingsFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
import React18 from "react";
import { gql as gql16, useQuery } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSLoader } from "@egds/react-core/loader";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IdentifierType as SummarizedIdentifierType, SummarizedReviews } from "@shared-ui/retail-product-summarized-reviews";
// src/components/product-review-details/__private/__fragments/categorized-listings.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSProgressBar } from "@egds/react-core/progress-bar";
import { EGDSSpacing } from "@egds/react-core/spacing";
var __CategorizedListingsFragment = gql(_templateObject());
var CategorizedListings = function(param) {
    var data = param.data;
    return data.progressBars.length ? /* @__PURE__ */ React.createElement(EGDSSpacing, {
        margin: {
            blockend: "two"
        },
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React.createElement(EGDSLayoutFlex, {
        direction: "column",
        space: "four"
    }, data.progressBars.map(function(progressBar, index) {
        return /* @__PURE__ */ React.createElement(EGDSLayoutFlexItem, {
            key: index
        }, /* @__PURE__ */ React.createElement(EGDSProgressBar, {
            percent: progressBar === null || progressBar === void 0 ? void 0 : progressBar.percent,
            progressDescription: (progressBar === null || progressBar === void 0 ? void 0 : progressBar.progressDescription) || "",
            title: (progressBar === null || progressBar === void 0 ? void 0 : progressBar.title) || ""
        }));
    }))) : null;
};
CategorizedListings.fragment = __CategorizedListingsFragment;
CategorizedListings.displayName = "CategorizedListings";
// src/components/product-review-details/__private/__fragments/review-disclaimer.tsx
import React16 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/text-info-section/product-text-info-section.tsx
import React15 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize3 } from "@egds/react-core/icons";
import { PositionType as PositionType2, UitkMenu as UitkMenu2, UitkMenuContainer as UitkMenuContainer2, UitkMenuTrigger as UitkMenuTrigger2 } from "@egds/react-core/menu";
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger2 } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText6 } from "uitk-react-text";
var _obj;
// ../internal/src/components/utils/uitk-text-utils.ts
var UitkTextWeightMap = Object.freeze((_obj = {}, _define_property(_obj, "BOLD" /* BOLD */ , "bold"), _define_property(_obj, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj, "REGULAR" /* REGULAR */ , "regular"), _obj));
var _obj1;
var UitkTextThemeMap = Object.freeze((_obj1 = {}, _define_property(_obj1, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj1, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj1, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj1, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj1, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj1, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj1, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _obj1));
// ../internal/src/components/text-info-section/product-text-info-content.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSMark, UitkMarkSize } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "@egds/react-core/icons";
var _obj2;
// ../internal/src/components/egds-icon/__private/spotlight-mapper.ts
var spotlightMapper = (_obj2 = {}, _define_property(_obj2, "INFO" /* INFO */ , "info"), _define_property(_obj2, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj2, "WARNING" /* WARNING */ , "warning"), _define_property(_obj2, "STANDARD" /* STANDARD */ , "standard"), _obj2);
// ../internal/src/components/egds-icon/egds-icon.tsx
var fragment = gql2(_templateObject1());
var EGDSIcon = function(param) {
    var className = param.className, defaultIconSize = param.defaultIconSize, data = param.data, spotlight = param.spotlight;
    var id = data.id, token = data.token;
    if (!id || !token) {
        return null;
    }
    var description = data.description, withBackground = data.withBackground, size = data.size, spotLightData = data.spotLight, title = data.title, theme = data.theme;
    return /* @__PURE__ */ React2.createElement(UitkIcon, {
        className: className,
        description: description,
        id: id,
        name: token,
        shadow: withBackground !== null && withBackground !== void 0 ? withBackground : void 0,
        size: size ? UitkIconSize[size] : defaultIconSize,
        spotlight: spotLightData ? spotlightMapper[spotLightData] : spotlight,
        title: title !== null && title !== void 0 ? title : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
EGDSIcon.fragment = fragment;
EGDSIcon.displayName = "UitkIcon";
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
var fragment2 = gql3(_templateObject2(), EGDSIcon.fragment);
var EGDSGraphicText = function(param) {
    var data = param.data, textProps = param.textProps, _param_size = param.size, size = _param_size === void 0 ? 200 : _param_size;
    if (!(data === null || data === void 0 ? void 0 : data.text)) {
        return null;
    }
    var text = data.text, graphic = data.graphic;
    var graphicElement = function() {
        if (graphic.__typename === "Icon") {
            return /* @__PURE__ */ React3.createElement(EGDSIcon, {
                data: graphic
            });
        }
        if (graphic.__typename === "Mark") {
            var _graphic_url;
            return /* @__PURE__ */ React3.createElement(EGDSSpacing2, {
                padding: {
                    inlineend: "two"
                }
            }, /* @__PURE__ */ React3.createElement(EGDSMark, {
                url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
                size: UitkMarkSize.SMALL
            }));
        }
    };
    return /* @__PURE__ */ React3.createElement(UitkText, _object_spread({
        size: size
    }, textProps), graphicElement(), text);
};
EGDSGraphicText.fragment = fragment2;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-link/egds-inline-link.tsx
import React4, { useMemo } from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkLink } from "uitk-react-link";
var _obj3;
// ../internal/src/components/utils/uitk-link-utils.ts
var linkSizeMapper = (_obj3 = {}, _define_property(_obj3, "SMALL" /* SMALL */ , "small"), _define_property(_obj3, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj3, "LARGE" /* LARGE */ , "large"), _obj3);
var _obj4;
var UILinkTargetMap = (_obj4 = {}, _define_property(_obj4, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj4, "INTERNAL" /* INTERNAL */ , "_self"), _obj4);
// ../internal/src/components/egds-link/egds-inline-link.tsx
var fragment3 = gql4(_templateObject3());
var EGDSInlineLink = function(param) {
    var className = param.className, data = param.data, _param_size = param.size, size = _param_size === void 0 ? "medium" : _param_size, _param_inline = param.inline, inline = _param_inline === void 0 ? true : _param_inline, onLinkClick = param.onLinkClick, _param_type = param.type, type = _param_type === void 0 ? "link" /* LINK */  : _param_type;
    var child = useMemo(function() {
        if (!data) {
            return null;
        }
        var text = data.text, action = data.action;
        return /* @__PURE__ */ React4.createElement(React4.Fragment, null, text, (action === null || action === void 0 ? void 0 : action.accessibility) && /* @__PURE__ */ React4.createElement("span", {
            className: "is-visually-hidden"
        }, action.accessibility));
    }, [
        data
    ]);
    var wrappedChildren = useMemo(function() {
        if (!data) {
            return null;
        }
        var action = data.action;
        switch(type){
            case "button" /* BUTTON */ :
                return /* @__PURE__ */ React4.createElement("button", {
                    type: "button"
                }, child);
            case "link" /* LINK */ :
            default:
                var _action_resource;
                return /* @__PURE__ */ React4.createElement("a", {
                    href: action === null || action === void 0 ? void 0 : (_action_resource = action.resource) === null || _action_resource === void 0 ? void 0 : _action_resource.value,
                    target: (action === null || action === void 0 ? void 0 : action.target) ? UILinkTargetMap[action.target] : void 0
                }, child);
        }
    }, [
        data,
        child,
        type
    ]);
    if (!(data === null || data === void 0 ? void 0 : data.text)) {
        return null;
    }
    var disabled = data.disabled, linkSize = data.linkSize;
    return /* @__PURE__ */ React4.createElement(UitkLink, {
        className: className,
        size: linkSize ? linkSizeMapper[linkSize] : size,
        onClickCapture: onLinkClick,
        disabled: disabled,
        inline: inline
    }, wrappedChildren);
};
EGDSInlineLink.fragment = fragment3;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-link/egds-standard-link.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
var fragment4 = gql5(_templateObject4(), EGDSIcon.fragment);
var EGDSStandardLink = function(_param) {
    var _param_data = _param.data, _param_data_action = _param_data.action, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, useRelativePath = _param_data_action.useRelativePath, disabled = _param_data.disabled, iconPosition = _param_data.iconPosition, icon = _param_data.icon, size = _param_data.size, text = _param_data.text, onClick = _param.onClick, uitkLinkProps = _object_without_properties(_param, [
        "data",
        "onClick"
    ]);
    var path = React5.useMemo(function() {
        switch(resource.__typename){
            case "HttpURI":
                return useRelativePath ? resource.relativePath : resource.value;
            default:
                return resource.value;
        }
    }, [
        resource,
        useRelativePath
    ]);
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React5.createElement(EGDSLink, _object_spread({
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        disabled: disabled
    }, uitkLinkProps), /* @__PURE__ */ React5.createElement("a", {
        target: UILinkTargetMap[target],
        href: path
    }, icon ? /* @__PURE__ */ React5.createElement(React5.Fragment, null, iconPosition === "LEADING" /* LEADING */  && /* @__PURE__ */ React5.createElement(EGDSIcon, {
        data: icon
    }), /* @__PURE__ */ React5.createElement("span", {
        "aria-hidden": Boolean(accessibility)
    }, text), iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React5.createElement(EGDSIcon, {
        data: icon
    })) : /* @__PURE__ */ React5.createElement("span", {
        "aria-hidden": Boolean(accessibility)
    }, text), accessibility && /* @__PURE__ */ React5.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSStandardLink.fragment = fragment4;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-paragraph/egds-paragraph-text.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSParagraph } from "@egds/react-core/text";
var fragment5 = gql6(_templateObject5());
var _obj5;
var EGDSParagraphSizeMap = (_obj5 = {}, _define_property(_obj5, "P1" /* P1 */ , 1), _define_property(_obj5, "P2" /* P2 */ , 2), _define_property(_obj5, "P3" /* P3 */ , 3), _obj5);
var EGDSParagraphText = function(param) {
    var data = param.data, size = param.size;
    if (!(data === null || data === void 0 ? void 0 : data.text)) {
        return null;
    }
    var text = data.text, style = data.style;
    var paraTextSize = size || (style ? EGDSParagraphSizeMap[style] : void 0);
    return /* @__PURE__ */ React6.createElement(EGDSParagraph, {
        size: paraTextSize
    }, text);
};
EGDSParagraphText.fragment = fragment5;
EGDSParagraphText.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
// ../internal/src/components/egds-heading/egds-heading.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSHeading as EGDSReactCoreHeading } from "@egds/react-core/text";
var fragment6 = gql7(_templateObject6());
var EGDSHeading = function(props) {
    var data = props.data, className = props.className, size = props.size, align = props.align, tag = props.tag;
    var accessibility = data.accessibility, text = data.text;
    if (!text) {
        return null;
    }
    return /* @__PURE__ */ React7.createElement(EGDSReactCoreHeading, {
        className: className,
        size: size,
        align: align,
        tag: tag,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0
    }, text);
};
EGDSHeading.fragment = fragment6;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var _obj6;
// ../internal/src/components/egds-stylized-text/__private/mapper.ts
var UitkThemeMap = Object.freeze((_obj6 = {}, _define_property(_obj6, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj6, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj6, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj6, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj6, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj6, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj6, "default", "default"), _obj6));
var _obj7;
var UitkWeightMap = Object.freeze((_obj7 = {}, _define_property(_obj7, "BOLD" /* BOLD */ , "bold"), _define_property(_obj7, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj7, "REGULAR" /* REGULAR */ , "regular"), _obj7));
var UitkSizeMap = Object.freeze({
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
});
var DecorativeMap = Object.freeze({
    HIGHLIGHT: "mark",
    LINE_THROUGH: "s",
    SUBSCRIPT: "sub",
    SUPERSCRIPT: "sup",
    UNDERLINE: "u"
});
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
var fragment7 = gql8(_templateObject7());
var EGDSStylizedText = function(_param) {
    var data = _param.data, _param_theme = _param.theme, theme = _param_theme === void 0 ? "default" : _param_theme, _param_weight = _param.weight, weight = _param_weight === void 0 ? "regular" : _param_weight, _param_size = _param.size, size = _param_size === void 0 ? 300 : _param_size, props = _object_without_properties(_param, [
        "data",
        "theme",
        "weight",
        "size"
    ]);
    if (!(data === null || data === void 0 ? void 0 : data.text)) {
        return null;
    }
    var text = data.text, decorative = data.decorative, accessibility = data.accessibility;
    var textProps = _object_spread({
        theme: (data === null || data === void 0 ? void 0 : data.theme) ? UitkThemeMap[data.theme] : theme,
        weight: (data === null || data === void 0 ? void 0 : data.weight) ? UitkWeightMap[data.weight] : weight,
        size: (data === null || data === void 0 ? void 0 : data.size) ? UitkSizeMap[data.size] : size
    }, props);
    var Decorative = decorative && DecorativeMap[decorative];
    var content = Decorative ? /* @__PURE__ */ React8.createElement(Decorative, null, text) : text;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(EGDSText, _object_spread({
        "aria-hidden": Boolean(accessibility)
    }, textProps), content), accessibility && /* @__PURE__ */ React8.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSStylizedText.fragment = fragment7;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment8 = gql9(_templateObject8());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data, spacing = param.spacing;
    if (!(data === null || data === void 0 ? void 0 : data.text)) {
        return null;
    }
    var text = data.text, accessibility = data.accessibility;
    return /* @__PURE__ */ React9.createElement(UitkText2, {
        className: className,
        inline: inline,
        size: size,
        align: align,
        spacing: spacing
    }, text, accessibility && /* @__PURE__ */ React9.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
EGDSPlainText.fragment = fragment8;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
var fragment9 = gql10(_templateObject9(), EGDSHeading.fragment, EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, headingProps = param.headingProps, data = param.data, inline = param.inline;
    switch(data.__typename){
        case "EGDSHeading":
            return /* @__PURE__ */ React10.createElement(EGDSHeading, _object_spread({
                data: data
            }, headingProps));
        case "EGDSStylizedText":
            return /* @__PURE__ */ React10.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: inline
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React10.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: inline
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React10.createElement(EGDSGraphicText, {
                data: data,
                size: size
            });
        default:
            return null;
    }
};
EGDSSpannableTextContent.fragment = fragment9;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
var fragment10 = gql11(_templateObject10(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_inlineContent;
    var align = props.align, data = props.data, styleProps = _object_without_properties(props, [
        "align",
        "data"
    ]);
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
        return /* @__PURE__ */ React11.createElement(React11.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React11.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
                data: item
            }, styleProps), {
                key: "spannable-item-".concat(index)
            }));
        }));
    }
    if (data === null || data === void 0 ? void 0 : data.text) {
        return /* @__PURE__ */ React11.createElement(UitkText3, _object_spread_props(_object_spread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    return null;
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/text-info-section/product-text-info-content.tsx
var fragment11 = gql12(_templateObject11(), EGDSParagraphText.fragment, EGDSInlineLink.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment);
var ProductTextInfoContent = function(param) {
    var className = param.className, size = param.size, data = param.data, inline = param.inline, index = param.index, handleClick = param.handleClick, paraTextSize = param.paraTextSize;
    switch(data.__typename){
        case "EGDSParagraph":
            return /* @__PURE__ */ React12.createElement(EGDSParagraphText, {
                className: className,
                data: data,
                size: paraTextSize
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React12.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                inline: inline,
                spacing: index === 0 ? void 0 : "three"
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React12.createElement(EGDSInlineLink, {
                data: data,
                size: "medium",
                inline: false,
                onLinkClick: handleClick
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React12.createElement(EGDSGraphicText, {
                data: data,
                size: size
            });
        default:
            return null;
    }
};
ProductTextInfoContent.fragment = fragment11;
ProductTextInfoContent.displayName = "ProductTextInfoContent";
// ../internal/src/components/text-info-section/render-legacy.tsx
import React14 from "react";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "@egds/react-core/icons";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "@egds/react-core/menu";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText5 } from "uitk-react-text";
// ../internal/src/components/text-info-section/policy-tooltip-section.tsx
import React13 from "react";
import { UitkCard } from "uitk-react-cards";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText as UitkText4 } from "uitk-react-text";
var PolicyTooltipSection = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React13.createElement(UitkSpacing, {
        padding: {
            inline: "three"
        }
    }, /* @__PURE__ */ React13.createElement(UitkCard, null, data.map(function(item, index) {
        return /* @__PURE__ */ React13.createElement(UitkText4, {
            key: "tooltip-text-".concat(index),
            size: 300,
            spacing: index === 0 ? void 0 : "six"
        }, item);
    })));
};
PolicyTooltipSection.displayName = "PolicyTooltipSection";
// ../internal/src/components/text-info-section/render-legacy.tsx
var renderSection = function(param) {
    var tooltipIcon = param.tooltipIcon, tooltipContent = param.tooltipContent, title = param.title, policyA11yText = param.policyA11yText, isMenuOpen = param.isMenuOpen, toggleMenuOpen = param.toggleMenuOpen;
    return /* @__PURE__ */ React14.createElement(UitkSpacing2, {
        margin: {
            blockstart: "one"
        }
    }, tooltipIcon ? /* @__PURE__ */ React14.createElement(UitkMenu, {
        isOpen: isMenuOpen,
        onTriggerClick: toggleMenuOpen
    }, /* @__PURE__ */ React14.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React14.createElement(UitkMoreInfoTrigger, {
        theme: tooltipIcon.theme || void 0
    }, /* @__PURE__ */ React14.createElement("button", {
        type: "button",
        "aria-label": policyA11yText !== null && policyA11yText !== void 0 ? policyA11yText : void 0
    }, /* @__PURE__ */ React14.createElement("span", null, title.text), /* @__PURE__ */ React14.createElement(UitkIcon2, {
        name: tooltipIcon.id,
        size: tooltipIcon.size ? UitkIconSize2[tooltipIcon.size] : void 0
    })))), tooltipContent && /* @__PURE__ */ React14.createElement(UitkMenuContainer, {
        autoPosition: true,
        position: PositionType.LEFT,
        width: 327
    }, /* @__PURE__ */ React14.createElement(PolicyTooltipSection, {
        data: tooltipContent
    }))) : /* @__PURE__ */ React14.createElement("div", null, /* @__PURE__ */ React14.createElement(UitkText5, {
        size: 300,
        theme: title.theme ? UitkTextThemeMap[title.theme] : void 0,
        weight: title.weight ? UitkTextWeightMap[title.weight] : void 0,
        "aria-hidden": Boolean(title.accessibility)
    }, title.text), title.accessibility && /* @__PURE__ */ React14.createElement("span", {
        className: "is-visually-hidden"
    }, title.accessibility)));
};
// ../internal/src/components/text-info-section/product-text-info-section.tsx
var __ProductTextInfoSection = gql13(_templateObject12(), ProductTextInfoContent.fragment);
var ProductTextInfoSection = function(param) {
    var data = param.data, handleTooltipLoad = param.handleTooltipLoad, trackTooltipToggle = param.trackTooltipToggle, trackTextInfoContentLinkClick = param.trackTextInfoContentLinkClick, _param_shouldShowLink = param.shouldShowLink, shouldShowLink = _param_shouldShowLink === void 0 ? false : _param_shouldShowLink, textSize = param.textSize, paraTextSize = param.paraTextSize;
    var _React15_useState = _sliced_to_array(React15.useState(false), 2), isMenuOpen = _React15_useState[0], setIsMenuOpen = _React15_useState[1];
    var pushEvent = React15.useRef(true);
    var pushTooltipSelectedEvent = React15.useRef(true);
    var pushTooltipHiddenEvent = React15.useRef(true);
    var title = data.title, tooltipContent = data.tooltipContent, tooltipIcon = data.tooltipIcon, policyA11yText = data.policyA11yText;
    var toggleMenuOpen = function() {
        if ((pushTooltipSelectedEvent.current || pushTooltipHiddenEvent.current) && trackTooltipToggle) {
            trackTooltipToggle(title === null || title === void 0 ? void 0 : title.text, isMenuOpen);
        }
        setIsMenuOpen(function(prevState) {
            return !prevState;
        });
    };
    if (data.message) {
        var _message_content;
        var icon = data.icon, message = data.message, accessibilityText = data.accessibilityText, theme = data.theme;
        var menuLabel = function() {
            return /* @__PURE__ */ React15.createElement(UitkMenuTrigger2, null, shouldShowLink ? /* @__PURE__ */ React15.createElement(UitkLink2, null, /* @__PURE__ */ React15.createElement("button", {
                type: "button",
                "aria-label": accessibilityText !== null && accessibilityText !== void 0 ? accessibilityText : void 0
            }, /* @__PURE__ */ React15.createElement("span", null, title.text), icon && /* @__PURE__ */ React15.createElement(UitkIcon3, {
                name: icon.id,
                size: icon.size ? UitkIconSize3[icon.size] : void 0
            }))) : /* @__PURE__ */ React15.createElement(UitkMoreInfoTrigger2, {
                theme: theme
            }, /* @__PURE__ */ React15.createElement("button", {
                type: "button",
                "aria-label": accessibilityText !== null && accessibilityText !== void 0 ? accessibilityText : void 0
            }, /* @__PURE__ */ React15.createElement("span", null, title.text), icon && /* @__PURE__ */ React15.createElement(UitkIcon3, {
                name: icon.id,
                size: icon.size ? UitkIconSize3[icon.size] : void 0
            }))));
        };
        if (icon && message && pushEvent.current && handleTooltipLoad) {
            pushEvent.current = false;
            handleTooltipLoad(title.text);
        }
        return /* @__PURE__ */ React15.createElement(UitkSpacing3, {
            margin: {
                blockstart: "one"
            }
        }, icon ? /* @__PURE__ */ React15.createElement(UitkMenu2, {
            isOpen: isMenuOpen,
            onTriggerClick: toggleMenuOpen
        }, menuLabel(), (message === null || message === void 0 ? void 0 : message.content) && (message === null || message === void 0 ? void 0 : message.content.length) > 0 && /* @__PURE__ */ React15.createElement(UitkMenuContainer2, {
            autoPosition: true,
            position: PositionType2.LEFT,
            width: shouldShowLink ? 300 : 327
        }, /* @__PURE__ */ React15.createElement(UitkSpacing3, {
            padding: shouldShowLink ? {
                inline: "four"
            } : {
                inline: "three"
            }
        }, /* @__PURE__ */ React15.createElement(UitkCard2, null, message === null || message === void 0 ? void 0 : (_message_content = message.content) === null || _message_content === void 0 ? void 0 : _message_content.map(function(item, index) {
            return /* @__PURE__ */ React15.createElement(ProductTextInfoContent, {
                data: item,
                key: index,
                index: index,
                size: textSize,
                paraTextSize: paraTextSize,
                handleClick: trackTextInfoContentLinkClick
            });
        }))))) : /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(UitkText6, {
            size: 300,
            theme: UitkTextThemeMap[title.theme || "SECONDARY" /* SECONDARY */ ],
            weight: UitkTextWeightMap[title.weight || "REGULAR" /* REGULAR */ ],
            "aria-hidden": Boolean(title.accessibility)
        }, title.text), title.accessibility && /* @__PURE__ */ React15.createElement("span", {
            className: "is-visually-hidden"
        }, title.accessibility)));
    }
    return renderSection({
        tooltipIcon: tooltipIcon,
        tooltipContent: tooltipContent,
        title: title,
        policyA11yText: policyA11yText,
        isMenuOpen: isMenuOpen,
        toggleMenuOpen: toggleMenuOpen
    });
};
ProductTextInfoSection.displayName = "ProductTextInfoSection";
ProductTextInfoSection.fragment = _object_spread_props(_object_spread({}, __ProductTextInfoSection), {
    __typename: "ProductTextInfoSection"
});
// src/components/product-review-details/__private/__fragments/review-disclaimer.tsx
var __ReviewDisclaimerFragment = gql14(_templateObject13(), ProductTextInfoSection.fragment);
var ReviewDisclaimer = function(param) {
    var data = param.data;
    var _data_title;
    var track = useClickTracker();
    var _ref = data.message || {}, content = _ref.content, openAnalytics = _ref.openAnalytics;
    var handleDisclaimerLabelClick = function() {
        var _ref = openAnalytics || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    };
    var handleMoreInfoLinkClick = function() {
        var _linkData_action;
        var linkData = content === null || content === void 0 ? void 0 : content.filter(function(item) {
            return item.__typename === "EGDSInlineLink";
        })[0];
        var _ref = (linkData === null || linkData === void 0 ? void 0 : (_linkData_action = linkData.action) === null || _linkData_action === void 0 ? void 0 : _linkData_action.analytics) || {}, referrerId = _ref.referrerId, linkName = _ref.linkName;
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    };
    var inlineDisclaimerView = content ? /* @__PURE__ */ React16.createElement(EGDSSpacing3, {
        padding: {
            blockstart: "four",
            blockend: "four"
        }
    }, /* @__PURE__ */ React16.createElement("div", null, content === null || content === void 0 ? void 0 : content.map(function(item, index) {
        return /* @__PURE__ */ React16.createElement(EGDSSpacing3, {
            key: item.__typename + index,
            padding: {
                blockend: "two"
            }
        }, /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(ProductTextInfoContent, {
            data: item,
            index: index,
            size: 200,
            handleClick: handleMoreInfoLinkClick,
            paraTextSize: 3
        })));
    }))) : null;
    return ((_data_title = data.title) === null || _data_title === void 0 ? void 0 : _data_title.text) ? /* @__PURE__ */ React16.createElement(ProductTextInfoSection, {
        data: data,
        shouldShowLink: true,
        trackTooltipToggle: handleDisclaimerLabelClick,
        trackTextInfoContentLinkClick: handleMoreInfoLinkClick,
        paraTextSize: 1
    }) : inlineDisclaimerView;
};
ReviewDisclaimer.fragment = __ReviewDisclaimerFragment;
ReviewDisclaimer.displayName = "ReviewDisclaimer";
// src/components/product-review-details/__private/__fragments/review-summary.tsx
import React17 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var __ReviewSummaryFragment = gql15(_templateObject14());
var highlightedMessagesThemeToEGDSTextWeight = {
    STRONG: "bold"
};
var ReviewSummary = function(param) {
    var data = param.data;
    var primary = data.primary, secondary = data.secondary, accessibilityLabel = data.accessibilityLabel, theme = data.theme;
    return /* @__PURE__ */ React17.createElement(EGDSLayoutFlex2, {
        alignItems: "start",
        direction: "column"
    }, /* @__PURE__ */ React17.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */ React17.createElement("div", null, accessibilityLabel && /* @__PURE__ */ React17.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), primary && /* @__PURE__ */ React17.createElement(EGDSText2, {
        size: 500,
        weight: theme && highlightedMessagesThemeToEGDSTextWeight[theme] || void 0,
        "aria-hidden": accessibilityLabel !== null
    }, primary))), /* @__PURE__ */ React17.createElement(EGDSLayoutFlexItem2, null, secondary && /* @__PURE__ */ React17.createElement(EGDSText2, {
        size: 400,
        spacing: "one"
    }, secondary)));
};
ReviewSummary.fragment = __ReviewSummaryFragment;
ReviewSummary.displayName = "ReviewSummary";
// src/components/product-review-details/product-review-details.tsx
var __Query = gql16(_templateObject15(), ReviewSummary.fragment, ReviewDisclaimer.fragment, CategorizedListings.fragment);
var ProductReviewDetails = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, batchKey = param.batchKey;
    var context = useBexApi().context;
    var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: {
            batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
        },
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (error) {
        return null;
    }
    var _ref = (data === null || data === void 0 ? void 0 : data.productReviewDetails) || {}, summary = _ref.summary, disclaimer = _ref.disclaimer, progressBarGroup = _ref.progressBarGroup;
    return /* @__PURE__ */ React18.createElement("div", {
        "data-stid": "product-reviews-details"
    }, loading && /* @__PURE__ */ React18.createElement(EGDSLayoutFlex3, null, /* @__PURE__ */ React18.createElement(EGDSLayoutPosition, {
        type: "absolute",
        position: {
            top: "center",
            left: "center"
        }
    }, /* @__PURE__ */ React18.createElement(EGDSLoader, null))), summary && /* @__PURE__ */ React18.createElement(ReviewSummary, {
        data: summary
    }), disclaimer && /* @__PURE__ */ React18.createElement(ReviewDisclaimer, {
        data: disclaimer
    }), /* @__PURE__ */ React18.createElement(SummarizedReviews, {
        inputs: {
            productIdentifier: {
                id: inputs.productIdentifier.id,
                type: SummarizedIdentifierType.PROPERTY_ID,
                travelSearchCriteria: inputs.productIdentifier.travelSearchCriteria
            }
        }
    }), progressBarGroup && /* @__PURE__ */ React18.createElement(CategorizedListings, {
        data: progressBarGroup
    }));
};
ProductReviewDetails.displayName = "sharedui-ProductReviewDetails";
// src/__generated__/types.ts
var IdentifierType = /* @__PURE__ */ function(IdentifierType2) {
    IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
    IdentifierType2["CART_ID"] = "CART_ID";
    IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
    IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
    IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
    IdentifierType2["OFFER_ID"] = "OFFER_ID";
    IdentifierType2["ORDER_ID"] = "ORDER_ID";
    IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
    IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
    return IdentifierType2;
}(IdentifierType || {});
export { IdentifierType, ProductReviewDetails };
//# sourceMappingURL=index.js.map